// extracted by mini-css-extract-plugin
module.exports = {"container":"_rFnimwTR","alert":"_eEUMIzMg","symbol":"_VvTPAJHY","bonusTitle":"_RSPM6Lpi","icon":"_ErQlEhlL","withButtonIcon":"_3FY00Flr","alertContent":"_cfo0kZzt"};